import React from 'react';

import { Dialog, DialogBody, DialogButtonsContainer, DialogHeader } from './styles'
import SchedullePeriods from 'components/SchedullePeriods/index';
import Button, { ButtonContainer } from "components/Button";


function ModalPremiumCalculation({ show, idOperation, handleConfirm, handleCancel, currentPeriod }) {
    return (
        <div style={{
            zIndex: 99,
            position: 'fixed',
            left: 0,
            top: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <Dialog canShow={show}>
                <DialogHeader>
                    PREMIUM CALCULATIONS
                </DialogHeader>
                <DialogBody>
                    <SchedullePeriods idOperation={idOperation} getLastImport currentPeriod={currentPeriod} />
                </DialogBody>
                <DialogButtonsContainer>
                    <Button secundary onClick={handleCancel}>CANCEL</Button>
                    <Button
                        primary
                        onClick={handleConfirm}
                        style={{ marginLeft: "10px" }}
                    >
                        CONFIRM IMPORT
                    </Button>
                </DialogButtonsContainer>
            </Dialog>
        </div>
    )
}

export default ModalPremiumCalculation;